import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let SenderSubjectOption: LazyOption = createLazyOption(
    {
        key: 'senderSubject',
        titleStringKey: 'optionTitle_senderSubjectOrder',
        searchTermsStringKey: 'optionTitle_senderSubjectOrder',
    },
    lazyFullModule,
    m => m.default
);
export default SenderSubjectOption;
